import { END_REQUEST, START_REQUEST } from '../reducers/global-loading-reducer';

export const startRequest = () => ({ type: START_REQUEST });

export const endRequest = () => ({ type: END_REQUEST });
